export default __webpack_public_path__ + "static/media/lucky1sllottory.845b5d19.png";